/**
 * set dom element sticky relative to parent container for .s-sticky-panel selectors
 */
import jQuery from 'jquery'

class StickyOnScroll {
  constructor(element, element2, thresholdElementOffset) {
    if ((!element, !element2)) {
      return false
    }

    this.$element = element
    this.$element2 = element2
    this.$offset = thresholdElementOffset
    this.$stickyOffset = jQuery('.s-milesNBonus-ribbon')
    this.$headerHeight = jQuery('.s-header__body').outerHeight()

    jQuery(window).resize(() => {
      this.ini()
    })

    jQuery(window).on('scroll', () => {
      this.ini()
    })
  }

  ini() {
    const stickyElement = this.$element
    const thresholdElement = this.$element2
    const stickyOffset = this.$stickyOffset

    let dif = 0
    if (this.$offset > 0) {
      dif =
        jQuery(thresholdElement).offset().top -
        jQuery('header').outerHeight() +
        this.$offset
    } else {
      dif =
        jQuery(thresholdElement).offset().top -
        jQuery('header').outerHeight() +
        jQuery(thresholdElement).outerHeight() / 2
    }

    if (jQuery(window).scrollTop() > dif) {
      jQuery(stickyElement).addClass('sticky')
    } else {
      jQuery(stickyElement).removeClass('sticky')
    }

    if (stickyOffset.length) {
      if (jQuery(stickyElement).css('top') !== 'auto') {
        const newTop = this.$headerHeight + stickyOffset.outerHeight()
        jQuery(stickyElement).css('top', newTop)
      }
    } else {
      jQuery(stickyElement).css('top', this.$headerHeight)
    }
  }
}
export default StickyOnScroll
